/**
 * Dados mock da tela "PLCom" — EXTREMAMENTE FIÉIS à aba "IMPOSTOS" da planilha
 * `documentacao-metodologias/reforma-tributaria/MOVIMENTAÇÕES  plcom teste.xlsx`
 * (período de referência: 08/2026).
 *
 * A estrutura abaixo espelha 1:1 os blocos e a disposição em colunas da
 * própria planilha (conferido célula a célula via ExcelJS, inclusive
 * fórmulas/resultados): coluna esquerda (B:D), coluna central (F:H) e
 * coluna direita (J:L), mais a tabela "ENTRADAS PLCOM" (full width, linhas
 * 35-48). Rótulos, valores, tags ("a crédito" / "Débito" / "A PAGAR") e
 * ordem das linhas seguem exatamente a planilha — nenhum valor foi
 * recalculado ou reinterpretado.
 *
 * Quando o PLCom for integrado a dados reais, este arquivo deve ser
 * substituído por um hook equivalente a `useReformaFiscalData` (ver
 * ../reforma-tributaria/hooks).
 */

export const periodo = "08/2026";

// ===== Resumo (hero) — valores literais da planilha, usados só para destaque visual =====
export const resumo = {
  faturamentoBruto: 1968922.23,
  faturamentoLiquido: 1762418.30,
  totalAPagar: 213473.94 + 24205.51 + 12254.07 + 21820.44 + 20199.29 + 92034.25,
  resultadoCreditoCompra: 39675.34,
};

// ============================================================
// COLUNA ESQUERDA — mesma ordem/colunas B:D da planilha
// ============================================================
export const colunaEsquerda = [
  {
    titulo: "INVENTARIO PLCOM 08.2026",
    linhas: [
      { label: "Estoque Inicial", valor: 2091589.30 },
      { label: "Estoque Final", valor: null },
    ],
  },
  {
    titulo: "RECEITA PLCOM 08.2026",
    linhas: [
      { label: "Vendas (Bruto)", valor: 1559963.33 },
      { label: "Serviços", valor: 408958.90 },
      { label: "TOTAL", valor: 1968922.23, destaque: "total" },
    ],
  },
  {
    titulo: "Deduções (Impostos a Débito e Devoluções)",
    linhas: [
      { label: "Devoluções (Vendas)", valor: 186874.66 },
      { label: "IPI", valor: 23191.28 },
      { label: "ICMS", valor: 223912.19 },
      { label: "PIS", valor: 24061.80 },
      { label: "COFINS", valor: 110827.49 },
      { label: "ICMS ST", valor: 24205.51 },
      { label: "ICMS Dev.", valor: 9285.97, tag: "a crédito" },
      { label: "PIS Dev.", valor: 2907.85, tag: "a crédito" },
      { label: "COFINS Dev.", valor: 13393.82, tag: "a crédito" },
      { label: "TOTAL", valor: 618660.57, destaque: "total" },
    ],
  },
  {
    titulo: "Despesas",
    linhas: [
      { label: "Fretes", valor: 631.86 },
      { label: "Energia / Desp. Com.", valor: 239.80 },
      { label: "Serviços Tomados", valor: 0 },
      { label: "Aluguéis", valor: 50000.00 },
      { label: "Combustível", valor: 0 },
      { label: "Consumo", valor: 591.87 },
      { label: "TOTAL", valor: 51463.53, destaque: "total" },
    ],
  },
  {
    titulo: "Impostos a Crédito + Compra Revenda",
    linhas: [
      { label: "ICMS", valor: 10438.25, tag: "a crédito" },
      { label: "PIS", valor: 1169.87, tag: "a crédito" },
      { label: "COFINS", valor: 5388.50, tag: "a crédito" },
      { label: "IPI Import.", valor: 0, tag: "a crédito" },
      { label: "ICMS Importação", valor: 0, tag: "a crédito" },
      { label: "Compra para Rev.", valor: 22678.72, tag: "Débito" },
      { label: "Importação", valor: 0, tag: "Débito" },
      { label: "Dif. Alíquotas", valor: 0, tag: "Débito" },
      { label: "RESULTADO", valor: 39675.34, destaque: "total" },
    ],
  },
];

// ============================================================
// COLUNA CENTRAL — mesma ordem/colunas F:H da planilha
// ============================================================
export const colunaCentral = [
  {
    titulo: "PLCOM",
    linhas: [
      { label: "Faturamento Bruto", valor: 1968922.23, destaque: "total" },
      { label: "Faturamento Líquido", valor: 1762418.30, destaque: "total" },
      { label: "Fat. entre Empresas / Func.", valor: 0 },
      { label: "Locação e Serv. Prestados", valor: 408958.90 },
      { label: "Devoluções Vendas", valor: -186874.66 },
      { label: "ICMS", valor: 223912.19 },
      { label: "IPI", valor: 23191.28 },
      { label: "PIS", valor: 24061.80 },
      { label: "COFINS", valor: 110827.49 },
    ],
  },
  {
    titulo: "Compras",
    linhas: [
      { label: "Compras Total", valor: 24142.25 },
      { label: "Compras Comercialização", valor: 22678.72 },
      { label: "Compras Consumo", valor: 591.87 },
      { label: "Devoluções Compras", valor: 277.06 },
      { label: "Serv. Tomados", valor: 0 },
      { label: "ICMS", valor: 10438.25 },
      { label: "IPI", valor: 1370.84 },
      { label: "PIS", valor: 3862.51 },
      { label: "COFINS", valor: 18793.24 },
    ],
  },
  {
    titulo: "Apuração",
    linhas: [
      { label: "ICMS", valor: 213473.94, tag: "A PAGAR" },
      { label: "ICMS ST + DIFAL Não Contrib.", valor: 24205.51, tag: "A PAGAR" },
      { label: "ISS", valor: 12254.07, tag: "A PAGAR" },
      { label: "IPI", valor: 21820.44, tag: "A PAGAR" },
      { label: "PIS", valor: 20199.29, tag: "A PAGAR" },
      { label: "COFINS", valor: 92034.25, tag: "A PAGAR" },
    ],
  },
];

// ============================================================
// COLUNA DIREITA — mesma ordem/colunas J:L da planilha
// ============================================================
export const colunaDireita = [
  {
    titulo: "Saldo Credor 08/2026",
    linhas: [
      { label: "ICMS", valor: 0 },
      { label: "PIS", valor: 0 },
      { label: "COFINS", valor: 0 },
      { label: "IPI", valor: 0 },
    ],
  },
  {
    titulo: "Notas Petrobras",
    linhas: [
      { label: "PIS", valor: 0 },
      { label: "COFINS", valor: 0 },
    ],
  },
  {
    titulo: "Nota Baixa Estoque NF",
    linhas: [
      { label: "ICMS", valor: 0 },
      { label: "PIS", valor: 0 },
      { label: "COFINS", valor: 0 },
    ],
  },
  {
    titulo: "NF (Areia — Regime Cumulativo)",
    linhas: [
      { label: "PIS", valor: 0 },
      { label: "COFINS", valor: 0 },
    ],
  },
  {
    titulo: "NF — Carta de Não Aproveitamento de ICMS",
    linhas: [
      { label: "ICMS", valor: 0 },
    ],
  },
];

// ============================================================
// ENTRADAS PLCOM — Detalhamento por CFOP (tabela full-width, linhas 35-48)
// ============================================================
export const entradasPorCfop = [
  { cfop: "1.353 / 2.353 / 1.932", descricao: "Fretes", valor: 631.86, icms: 15.82, icmsSt: null, bcPisCofins: 616.04, pis: 10.16, cofins: 46.82, ipi: 0 },
  { cfop: "1.253 / 1.303", descricao: "Energia", valor: 239.80, icms: null, icmsSt: null, bcPisCofins: 191.23, pis: 3.16, cofins: 14.53, ipi: null },
  { cfop: "1.933 / 2.933", descricao: "Serviços Tomados", valor: 0, icms: 0, icmsSt: null, bcPisCofins: 0, pis: 0, cofins: 0, ipi: null },
  { cfop: "1.933", descricao: "Locação", valor: 50000.00, icms: null, icmsSt: null, bcPisCofins: 50000.00, pis: 825.00, cofins: 3800.00, ipi: null },
  { cfop: "1.653 / 2.653", descricao: "Combustível (Consumo)", valor: 0, icms: 0, icmsSt: null, bcPisCofins: 0, pis: 0, cofins: 0, ipi: null },
  { cfop: "1.556 / 2.556 / 1.407 / 2.407", descricao: "Uso e Consumo", valor: 591.87, icms: null, icmsSt: null, bcPisCofins: 0, pis: 0, cofins: 0, ipi: null },
  { cfop: "1.102 / 2.102 / 2.403 / 1.403 / 1.652", descricao: "Revendas", valor: 22678.72, icms: 1136.46, icmsSt: null, bcPisCofins: 20285.29, pis: 334.71, cofins: 1541.68, ipi: 0 },
  { cfop: "3.102", descricao: "Importação", valor: 0, icms: 0, icmsSt: null, bcPisCofins: 0, pis: 0, cofins: 0, ipi: 0 },
  { cfop: "5.202 / 5.411", descricao: "Devolução de Compra", valor: 277.06, icms: 9285.97, icmsSt: null, bcPisCofins: 0, pis: 218.37, cofins: 3.61, ipi: 16.60 },
  { cfop: "1.202 / 2.202 / 1.411", descricao: "Devolução de Venda", valor: 186874.66, icms: 9285.97, icmsSt: 0, bcPisCofins: 176234.45, pis: 2907.85, cofins: 13393.82, ipi: 1354.24 },
  { cfop: "", descricao: "TOTAL", valor: 74419.31, icms: 10438.25, icmsSt: null, bcPisCofins: 0, pis: 3862.51, cofins: 18793.24, ipi: 1370.84, destaque: "total" },
];
